var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_52",
    "data-name": "Group 52",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.199,
    height: 25.999,
    viewBox: "0 0 31.199 25.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M68.249,8.235H40.95a1.817,1.817,0,0,0-1.379.672,2.591,2.591,0,0,0,0,3.245,1.815,1.815,0,0,0,1.379.671h27.3a1.815,1.815,0,0,0,1.379-.671,2.591,2.591,0,0,0,0-3.245,1.817,1.817,0,0,0-1.379-.672",
    transform: "translate(-39 2.47)",
    fill: "#be1622"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M40.95,4.588h27.3a1.817,1.817,0,0,0,1.379-.672A2.514,2.514,0,0,0,70.2,2.293,2.516,2.516,0,0,0,69.629.672,1.817,1.817,0,0,0,68.249,0H40.95a1.817,1.817,0,0,0-1.379.672A2.516,2.516,0,0,0,39,2.293a2.514,2.514,0,0,0,.571,1.622,1.817,1.817,0,0,0,1.379.672",
    transform: "translate(-39 0)",
    fill: "#be1622"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M68.249,16.471H40.95a1.817,1.817,0,0,0-1.379.672,2.591,2.591,0,0,0,0,3.245,1.815,1.815,0,0,0,1.379.671h27.3a1.815,1.815,0,0,0,1.379-.671,2.591,2.591,0,0,0,0-3.245,1.817,1.817,0,0,0-1.379-.672",
    transform: "translate(-39 4.941)",
    fill: "#be1622"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.adc334496733b369d348be235443f200.svg";
export { ForwardRef as ReactComponent };